import React from 'react';

interface AlertProps {
    heading: string;
    message?: string;
}

const Alert: React.FC<AlertProps> = ({ heading, message }) => (
    <>
        <div className='alert alert-warning' role='alert'>
            <span className='ms-order-history__alert-heading'>{heading}</span>
        </div>
        <p className='ms-order-history__alert-message'>{message}</p>
    </>
);

export default Alert;
